const config = {
  links: {
    termsAndConditions: "https://groupup.cc/legal/terms-and-conditions",
    privacyPolicy: "https://groupup.cc/legal/privacy-policy",
    website: "https://groupup.cc",
    googlePlay: "https://play.google.com/store/apps/details?id=com.groupup.live.app",
  },
};

export default config;
